import { casesStatusUpdateApi, raiseNotificationApi } from 'Constants'
import { getCaseType } from 'Utils';
import React, { useState } from 'react'
import { Context } from 'Context/Context';
import { useContext } from 'react';
import ConflictModal from 'Modals/ConflictModal';
import TestModal from 'Modals/TestModal';
import { toast } from 'react-toastify';
import useIsMobile from 'Hooks/useIsMobile';
import { useNavigate } from 'react-router-dom';
import CaseCard, { StatusPill } from './CaseCard';
import { openCasePage, fmtDate } from './CaseStage';
import { CardStack, CardNotice, CaseBtn, EmptyState } from './CaseListUI';

function ApprovedCases({attorney, cases, setUpdateComp, reqRevCountArr, emptyText}) {
   
    const {userDetails, setUserDetails, setUpdateLoggedinData, makeApiCallFunc} = useContext(Context);
    const userInfo = attorney ? attorney?.userId :  userDetails;
    const [showModal, setShowModal] = useState(false);
    const [closeMsg, setCloseMsg] = useState('');
    const [refreshList, setRefreshList] = useState(false);
    const [index, setIndex] = useState(null);
    const isMobile = useIsMobile();
    const navigate = useNavigate();
    // full case page (handoff §7b); assistants working for an attorney keep the popup
    const usePage = !attorney;
    const [showEachCase, setShowEachCase] = useState(false);
    const [singleCase, setSingleCase] = useState(null);
    const [refreshCaseId, setRefreshCaseId] = useState(null);
    
    const onViewMore = (e, index) => {
        setIndex(index)
        setShowModal(true);
        e.stopPropagation();
    }
    const noConflict = () => {
        const owner = cases?.[index]?.caseDetails?.owner;
        const caseId = cases?.[index]?.caseDetails?._id;
        setShowModal(false);
        makeApiCallFunc(
            casesStatusUpdateApi,
            {
                caseId: caseId,
                userId: userInfo._id,
                assistantId: attorney ? userDetails._id : null,
                caseStatus:"noConflict"
            },
            ({data}) => {
                const fullname = attorney ? attorney?.userId?.firstName +" "+ attorney?.userId?.lastName : userDetails?.firstName+" "+userDetails.lastName;
                const notificationObj = {
                    title : "Congratulations, Your case is being viewed by " + fullname,  
                    is_read : false,
                    sender: "professional",
                    caseNumber: cases?.[index]?.caseDetails?.caseNumber,
                    notificationCategory: 1,
                    type: "3",
                    receiver:  owner,
                    additionalInfo : {
                        "caseId": caseId,
                        "userId": userDetails._id
                    },
                    // content: "The legal professional "+userDetails?.firstName+" "+userDetails.lastName+" has given conflict clearence for your case "+getCaseType(cases?.[index]?.caseDetails?.caseType) + "-" + cases?.[index]?.caseDetails?.caseNumber +". The professional is now viewing all your case details and personal contact informations",
                   content: 
                   userDetails?.role === 5 ?
                    "The Law firm case manager "+ userDetails?.firstName +" "+ userDetails?.lastName +" has indicated that they do not have any conflicts with regard to potentially representing you in this "+getCaseType(cases?.[index]?.caseDetails?.caseType)+ "-" + cases?.[index]?.caseDetails?.caseNumber+".  The law firm will now view your case details."
                    :
                    userInfo?.isUserFunder ?
                    "The litigation funder "+ userDetails?.company +" has indicated that they do not have any conflicts with regard to potentially funding the representation of your "+getCaseType(cases?.[index]?.caseDetails?.caseType)+ "-" + cases?.[index]?.caseDetails?.caseNumber+".  The litigation funder will now view your case details."
                    :
                    attorney ? 
                    "The attorney "+ attorney?.userId?.firstName +" "+ attorney?.userId?.lastName +" has indicated that they do not have any conflicts with regard to potentially representing you in this "+getCaseType(cases?.[index]?.caseDetails?.caseType)+ "-" + cases?.[index]?.caseDetails?.caseNumber+".  The attorney will now view your case details."
                    :
                    "The attorney "+ userDetails?.firstName +" "+ userDetails?.lastName +" has indicated that they do not have any conflicts with regard to potentially representing you in this "+getCaseType(cases?.[index]?.caseDetails?.caseType)+ "-" + cases?.[index]?.caseDetails?.caseNumber+".  The attorney will now view your case details."
                }
                raiseNotification(notificationObj,
                    () => {
                        console.log("caseid",caseId);
                        console.log("index",cases?.[index]);
                        
                        setRefreshCaseId(caseId);
                        setShowEachCase(true);
                        setSingleCase(cases?.[index]);

                        setRefreshList(true);
                        setCloseMsg(cases?.[index]?.caseDetails?.caseNumber + " moved to My Cases successfully.");
                    }
                );
              
                
                
            },
            (data) => console.log(data),
        )
    }
    
    const raiseNotification = (notificationObj, sucCallback=()=>{}) => {
       
        makeApiCallFunc(
            raiseNotificationApi, 
            notificationObj, 
             (data) => {
                console.log(data);
                sucCallback();
             },
             (error) => console.log(error)
            )
    }
    const onConflict = () => {
        const owner = cases?.[index]?.caseDetails?.owner;
        const id = cases?.[index]?.caseDetails?._id;

        const caseType = cases?.[index]?.caseType;
        setShowModal(false);
        
        makeApiCallFunc(
            casesStatusUpdateApi,
            {
                userId: userInfo?._id,
                caseId: id,
                assistantId: attorney ? userDetails._id : null,
                caseStatus: "conflict"
            },
            (data) => {
                const userType = userInfo?.isUserFunder ? "Litigation funder" : "Attorney";
               //test
                const notificationObj = {
                    title : userType + " removed from case " + getCaseType(caseType) + " " + cases?.[index]?.caseDetails?.caseNumber,
                    is_read : false,
                    sender: "professional",
                    notificationCategory: 1,
                    caseNumber: cases?.[index]?.caseDetails?.caseNumber,
                    type: "4",
                    receiver:  owner,
                    additionalInfo : {
                        "caseId": id,
                        "userId": userInfo._id
                    },
                    content: "Unfortunately, the "+userType+" "+userInfo?.firstName+" "+userInfo.lastName+" is no longer interested in this case. You may continue to seek other "+userType+"s available for your case."
                }
                //setRefreshList(true);
                console.log(notificationObj);
                
                toast.info(cases?.[index]?.caseDetails?.caseNumber + " removed from your list due to conflict.");
                raiseNotification(notificationObj, setUpdateComp(prev => !prev))
                //setUpdateLoggedinData((prev) => !prev)

            },
            (data) => console.log(data),
        )
    }
    const submit = (key) => {
      
        if(!cases?.[key]?.is_deleted)
        {
            setShowEachCase(true);
            setSingleCase(cases?.[key]);
        }
       
    }
     const showToastMsg = () => {
        console.log("closeMsg", closeMsg);
            if(closeMsg && closeMsg !== '')
            {
                toast.info(closeMsg, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
                setCloseMsg('');
            }   
            
        }
  return (
    <>
        {
        showEachCase && singleCase &&
            <TestModal
            setCloseMsg={setCloseMsg}
            reqRevCountArr={reqRevCountArr}
            attorney={attorney}
            caseId={refreshCaseId}
            setRefreshList={setRefreshList}
            onClose={()=>{
                       if (closeMsg) {
                           toast.info(closeMsg);
                       }
                       setShowEachCase(false);   // close modal
                       setCloseMsg('');          // reset message
                       if(refreshList)
                        {
                            setUpdateComp(prev => !prev);
                            setRefreshList(false);
                        }
            }} uploadNew={showEachCase} caseData={singleCase} setSingleCase={setSingleCase} setUpdateComp={setUpdateComp}/>
        }
        {
            showModal &&
            <ConflictModal
            uploadNew={showModal}
            caseDetails={cases?.[index]?.caseDetails}
            onClose={() => setShowModal(false)}
            noConflict={noConflict}
            onConflict={onConflict}
            />
        }
        {
            cases?.length ?
            <CardStack>
                {cases.map((detail, key) => {
                    const team = detail?.assistantId?.length ? detail.assistantId[0] : null;
                    const pendingClose = reqRevCountArr?.[detail?.caseDetails?._id]?.reqToClose;
                    return (
                        <CaseCard
                            key={detail?._id || key}
                            detail={detail.caseDetails}
                            userInfo={userInfo}
                            reqRevCountArr={reqRevCountArr}
                            onOpen={isMobile ? undefined : () => (usePage ? openCasePage(navigate, detail) : submit(key))}
                            headerPill={usePage ? <StatusPill tone="green">Approved by client{fmtDate(detail.updated_at) ? ' · ' + fmtDate(detail.updated_at) : ''}</StatusPill> : undefined}
                            notices={pendingClose ? <CardNotice tone="danger">This case is pending closing by the client</CardNotice> : null}
                            footerNote={team ? <>Requested by team <b className="font-semibold text-navy">{team.firstName} {team.lastName}</b></> : null}
                            actions={usePage ? <CaseBtn onClick={() => openCasePage(navigate, detail)} full={isMobile} style={isMobile ? { height: '46px', fontSize: '14px' } : undefined}>Open case →</CaseBtn> : <>
                                <CaseBtn variant="secondary" onClick={() => submit(key)} full={isMobile}>View case</CaseBtn>
                                <CaseBtn onClick={(e) => onViewMore(e, key)} full={isMobile} style={isMobile ? { height: '46px', fontSize: '14px' } : undefined}>Check for conflict →</CaseBtn>
                            </>}
                        />
                    )
                })}
            </CardStack>
            :
            <EmptyState title={emptyText?.title || 'No approved cases yet'} body={emptyText?.body || 'Cases will appear here as they move into this stage. Try changing your filters.'} />
        }
    </>
  )
}

export default ApprovedCases;
